import * as React from 'react';
import * as Model from '../../api/model';
import { TableRow, TableCell, Tooltip, IconButton, CircularProgress, Snackbar, Dialog, DialogTitle, DialogContent, DialogActions, Button, DialogContentText } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import { API } from '../../api';

//#region UI configuration
const strings = {
    deleteButton: 'Delete',
    cancelButton: 'Cancel',
    deleteError: 'Unable to delete (item can be used)',
    deleteDialogTitle: 'Confirm',
    deleteDialogMessage: 'Are you sure?'
};
//#endregion

//#region Props & State
interface WineryItemProps {
    item: Model.Winery;
    selected: boolean;
    onItemSelected: (item: Model.Winery) => void
    onItemRemoved: (id: number) => void
}
interface WineryItemState {
    removing: boolean;
    showConfirm: boolean;
    error: null | string;
}

const initialState: WineryItemState = {
    removing: false,
    showConfirm: false,
    error: null
};
//#endregion

class WineryItem extends React.Component<WineryItemProps, WineryItemState> {

    constructor(props: WineryItemProps) {
        super(props);

        this.state = initialState;
    }

    render() {
        const { item, selected, onItemSelected } = this.props;
        const { removing, error, showConfirm } = this.state;

        return (
            <React.Fragment>
                <TableRow hover={true} selected={selected}>
                    <TableCell onClick={() => onItemSelected(item)} numeric={true}>{item.id}</TableCell>
                    <TableCell onClick={() => onItemSelected(item)}>{!!item.appellation ? item.appellation.name : '-'}</TableCell>
                    <TableCell onClick={() => onItemSelected(item)}>{item.domain}</TableCell>
                    <TableCell onClick={() => onItemSelected(item)}>{item.classification.name}</TableCell>
                    <TableCell onClick={() => onItemSelected(item)}>{!!item.producer ? item.producer : '-'}</TableCell>
                    <TableCell>
                        {!removing && <Tooltip title={strings.deleteButton}>
                            <IconButton onClick={this.onDeleteClick}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>}
                        {removing && <CircularProgress size={45} />}
                    </TableCell>
                </TableRow>

                <Dialog open={showConfirm}>
                    <DialogTitle>{strings.deleteDialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{strings.deleteDialogMessage}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onDeleteCancelClick} color="primary">{strings.cancelButton}</Button>
                        <Button onClick={this.onDeleteConfirmedClick} color="primary">{strings.deleteButton}</Button>
                    </DialogActions>
                </Dialog>

                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={!!error}
                    autoHideDuration={6000}
                    onClose={this.onErrorClose}
                    message={<span>{error}</span>}
                    action={[
                        <IconButton
                            key="close"
                            color="inherit"
                            onClick={this.onErrorClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    ]}
                />
            </React.Fragment>
        );
    }

    private onDeleteClick = () => {
        this.setState({ showConfirm: true });
    }

    private onDeleteCancelClick = () => {
        this.setState({ showConfirm: false });
    }

    private onDeleteConfirmedClick = () => {
        const { item, onItemRemoved } = this.props;
        this.setState({ removing: true, showConfirm: false });
        API.winery.delete(item.id)
            .then(() => {
                onItemRemoved(item.id);
            })
            .catch(() => {
                this.setState({ removing: false, error: strings.deleteError });
            });
    }

    private onErrorClose = () => {
        this.setState({ error: null });
    }
}

export default WineryItem;



// WEBPACK FOOTER //
// ./src/modules/winery/WineryItem.tsx